import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface Inputs {
  noteId: string;
  text: string;
  highlighted: boolean;
}

interface Props {
  topicId?: string;
	onSuccess?: () => void;
  onError?: (res: AxiosError) => void;
}

export const useSaveNoteTopic = ({
  topicId,
	onSuccess,
  onError
}: Props) => {
  const queryClient = useQueryClient();
	const {
		mutate: onSaveNoteTopic,
    ...rest
	} = useMutation({
		mutationFn: async ({noteId, ...data}: Inputs) => {
      if (topicId) 
        return axios.patch(`/note-topics/${topicId}`, data);
      return axios.post('/note-topics', {...data, noteId});
		},
		onSuccess: ({ data: { topic } }) => {
      queryClient.invalidateQueries({ 
        queryKey: ['topics', { noteId: topic.noteId }] 
      });  
      if (onSuccess)
        onSuccess();
    },
    onError
	});

	return { onSaveNoteTopic, ...rest };
};
